import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Badge, Box, Callout, Collapse, Column, Divider, FullRow, Row, Switch, TextButton, Typography } from 'seagull';
import { Bulb24 } from 'seagull/icons';
import { VariableInlineRenderer } from '~/components/AgreementStudioPage/TemplateVariables/VariableInlineRenderer/VariableInlineRenderer';
import { Intent } from '~/infra/access-control';
import styles from './ServiceItem.module.scss';
export const DesktopServiceItem = (param)=>{
    let { service, isOptional, isSelected, onToggle, discountBadgeData, getBillingBadgeText, futureBillingText, useInlineFutureBilling, renderPrice, hasIncludedServices, hasExpandableContent, getServiceDescription, ServiceItemTestIds } = param;
    var _service_bundle;
    const [isExpanded, setIsExpanded] = useState(false);
    return /*#__PURE__*/ _jsx(Column, {
        className: styles.serviceItem,
        testId: ServiceItemTestIds.Root(),
        children: /*#__PURE__*/ _jsxs(Column, {
            className: styles.card,
            children: [
                /*#__PURE__*/ _jsxs(Column, {
                    gap: 8,
                    children: [
                        /*#__PURE__*/ _jsxs(FullRow, {
                            gap: 16,
                            alignItems: "center",
                            children: [
                                isOptional && /*#__PURE__*/ _jsx(Switch, {
                                    intent: Intent.SelectOptionalService,
                                    checked: isSelected,
                                    testId: ServiceItemTestIds.OptionalToggle(),
                                    onChange: onToggle
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    className: styles.serviceName,
                                    skin: "standard",
                                    ellipsis: true,
                                    testId: ServiceItemTestIds.Name(),
                                    children: /*#__PURE__*/ _jsx(VariableInlineRenderer, {
                                        text: service.name
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Row, {
                                    gap: 8,
                                    children: [
                                        discountBadgeData && /*#__PURE__*/ _jsx(Badge, {
                                            rounded: true,
                                            outlined: true,
                                            skin: "primary",
                                            className: styles.billingBadge,
                                            testId: ServiceItemTestIds.DiscountBadge(),
                                            children: discountBadgeData.text
                                        }),
                                        /*#__PURE__*/ _jsx(Badge, {
                                            rounded: true,
                                            outlined: true,
                                            skin: "primary",
                                            className: styles.billingBadge,
                                            testId: ServiceItemTestIds.BillingBadge(),
                                            children: getBillingBadgeText()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    testId: ServiceItemTestIds.Price(),
                                    children: renderPrice()
                                }),
                                hasExpandableContent && /*#__PURE__*/ _jsxs(Row, {
                                    gap: 16,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ _jsx(Divider, {
                                            orientation: "vertical",
                                            margin: 0,
                                            className: styles.viewMoreDivider
                                        }),
                                        /*#__PURE__*/ _jsx(TextButton, {
                                            underline: "none",
                                            weight: "normal",
                                            variant: "paragraph2",
                                            className: styles.viewMoreButton,
                                            onClick: ()=>setIsExpanded(!isExpanded),
                                            testId: ServiceItemTestIds.ExpandButton(),
                                            children: isExpanded ? 'View less' : 'View more'
                                        })
                                    ]
                                })
                            ]
                        }),
                        hasIncludedServices && /*#__PURE__*/ _jsxs(Column, {
                            gap: 4,
                            testId: ServiceItemTestIds.IncludedServices(),
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph2",
                                    weight: "normal",
                                    children: "Included services:"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: styles.includedServicesList,
                                    children: (_service_bundle = service.bundle) === null || _service_bundle === void 0 ? void 0 : _service_bundle.services.map((includedService)=>/*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(Typography, {
                                                variant: "paragraph2",
                                                skin: "secondary",
                                                weight: "light",
                                                children: /*#__PURE__*/ _jsx(VariableInlineRenderer, {
                                                    text: includedService.name
                                                })
                                            })
                                        }, includedService.serviceTemplateId))
                                })
                            ]
                        }),
                        futureBillingText && (useInlineFutureBilling ? /*#__PURE__*/ _jsxs(Row, {
                            gap: 8,
                            alignItems: "center",
                            className: styles.futureBillingInline,
                            testId: ServiceItemTestIds.FutureBillingCallout(),
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    className: styles.futureBillingIcon,
                                    children: /*#__PURE__*/ _jsx(Bulb24, {
                                        width: 24,
                                        height: 24
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph2",
                                    weight: "light",
                                    children: futureBillingText
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx(Callout, {
                            variant: "paragraph2",
                            intent: "info",
                            icon: /*#__PURE__*/ _jsx(Bulb24, {
                                width: 24,
                                height: 24
                            }),
                            classes: {
                                wrapper: styles.futureBillingCalloutWrapper,
                                main: styles.futureBillingCallout
                            },
                            testId: ServiceItemTestIds.FutureBillingCallout(),
                            children: futureBillingText
                        }))
                    ]
                }),
                hasExpandableContent && /*#__PURE__*/ _jsx(Collapse, {
                    in: isExpanded,
                    children: /*#__PURE__*/ _jsx(Column, {
                        gap: 16,
                        className: styles.expandedContent,
                        testId: ServiceItemTestIds.ExpandedContent(),
                        children: getServiceDescription({
                            hideIncludedServices: true
                        })
                    })
                })
            ]
        })
    });
};
